import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import _defineProperty from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';
// import Layout2 from '@/layout/index2'

/**
 * Note:子菜单仅在route children.length>=1时出现
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   如果设置为true，项目将不会显示在侧栏中（默认值为false）
 * alwaysShow: true               如果设置为true，将始终显示根菜单
 *                                如果未设置alwaysShow，则当项目有多个子路线时，
 *                               它将变为嵌套模式，否则不显示根菜单
 * redirect: noRedirect           如果设置为noRedirect，则面包屑中不会重定向
 * name:'router-name'             该名称由<keep alive>使用（必须设置！！！）
 * meta : {
    roles: ['admin','editor']    控制页面角色（可以设置多个角色）
    title: 'title'               侧边栏和面包屑中显示的名称（推荐集）
    icon: 'svg-name'             图标显示在侧边栏中
    breadcrumb: false            如果设置为false，则项目将隐藏在面包屑中（默认值为true）
    activeMenu: '/example/list'  如果设置路径，侧边栏将突出显示您设置的路径
  }
 */

/**
 * constantRoutes
 * 没有权限要求的基页
 * 所有角色都可以访问
 */
export var constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return import('@/views/redirect/index');
    }
  }]
}, {
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/booking/instrument',
  hidden: true
},
// {
//   // 安防系统实验室详情
//   path: '/securityECM',
//   name: 'securityECM',
//   component: Layout,
//   children: [
//     {
//       path: 'securityECMDetails',
//       name: 'securityECMDetails',
//       meta: {
//         title: '设备详情'
//       },
//       component: () => import('@/views/securityManagement/ECM/securityECMDetails/index')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'instrumentCatManage'
// }
{
  path: '/baseSystem',
  name: 'baseSystem',
  component: Layout,
  children: [{
    path: 'noticeDetail',
    name: 'noticeDetail',
    meta: {
      title: '发布通知公告'
    },
    component: function component() {
      return import('@/views/system/noticeManagement/components/notice');
    }
  }],
  hidden: true
}, {
  path: '/baseSystem',
  name: 'baseSystem',
  component: Layout,
  children: [{
    path: 'instrumentList/instrumentDetail',
    name: 'instrumentDetail',
    meta: {
      title: '仪器详情'
    },
    component: function component() {
      return import('@/views/system/instruManage/instrumentList/components/instrumentDetails');
    }
  }],
  hidden: true
},
// {
//   path: '/baseSystem',
//   name: 'baseSystem',
//   component: Layout,
//   children: [
//     {
//       path: 'instrumentCname',
//       name: 'instrumentCname',
//       meta: {
//         title: '仪器名称'
//       },
//       component: () =>
//         import('@/views/system/instrumentCname')
//     }
//   ],
//   hidden: true
// },
{
  path: '/baseSystem',
  name: 'baseSystem',
  component: Layout,
  children: [{
    path: 'instrumentList/instrumentDialog',
    name: 'instrumentDialog',
    meta: {
      title: '添加、编辑仪器'
    },
    component: function component() {
      return import('@/views/system/instruManage/instrumentList/components/InstrumentDialog');
    }
  }],
  hidden: true
}, {
  path: '/baseSystem',
  name: 'baseSystem',
  component: Layout,
  children: [{
    path: 'customProcessList/checkProcessDetail',
    name: 'customProcessList/checkProcessDetail',
    meta: {
      title: '自定义验收流程'
    },
    component: function component() {
      return import('@/views/system/checkProcessDetail');
    }
  }],
  hidden: true
}, {
  path: '/baseSystem',
  name: 'baseSystem',
  component: Layout,
  children: [{
    path: 'customProcessList/processEdit',
    name: 'customProcessList/processEdit',
    meta: {
      title: '自定义审批流程'
    },
    component: function component() {
      return import('@/views/system/processEdit');
    }
  }],
  hidden: true
}, {
  path: '/baseSystem',
  name: 'baseSystem',
  component: Layout,
  children: [{
    path: 'customProcessList/processIncrease',
    name: 'customProcessList/processIncrease',
    meta: {
      title: '新增自定义审批流程'
    },
    component: function component() {
      return import('@/views/system/processIncrease');
    }
  },
  // 华工自定义审批路由
  {
    path: 'customApproval/processIncrease',
    name: 'customApproval/processIncrease',
    meta: {
      title: '新增自定义审批流程'
    },
    component: function component() {
      return import('@/views/system/customApproval/pages/processIncrease');
    }
  }, {
    path: 'customApproval/processEdit',
    name: 'customApproval/processEdit',
    meta: {
      title: '自定义审批流程'
    },
    component: function component() {
      return import('@/views/system/customApproval/pages/processEdit');
    }
  }, {
    path: 'customApproval/checkProcessDetail',
    name: 'customApproval/checkProcessDetail',
    meta: {
      title: '自定义验收流程'
    },
    component: function component() {
      return import('@/views/system/customApproval/pages/checkProcessDetail');
    }
  }],
  hidden: true
}, {
  path: '/supplier',
  name: 'supplier',
  component: Layout,
  children: [{
    path: 'supplierInfoDetail',
    name: 'supplierInfoDetail',
    meta: {
      title: '供应商合作协议详情'
    },
    component: function component() {
      return import('@/views/supplier/supplierCooperation/components/supplierInfo');
    }
  }],
  hidden: true
}, {
  path: '/supplier',
  name: 'supplier',
  component: Layout,
  children: [{
    path: 'cooperation',
    name: 'cooperation',
    meta: {
      title: '供应商合作协议'
    },
    component: function component() {
      return import('@/views/supplier/supplierCooperation/components/cooperationDialog');
    }
  }],
  hidden: true
}, {
  path: '/supplier',
  name: 'supplier',
  component: Layout,
  children: [{
    path: 'supplierDetail',
    name: 'supplierDetail',
    meta: {
      title: '供应商详情'
    },
    component: function component() {
      return import('@/views/supplier/supplierManagement/components/supplierDetailsDialog');
    }
  }],
  hidden: true
}, {
  path: '/safeInspection',
  name: 'safeInspection',
  component: Layout,
  children: [{
    path: 'inspectionTaskDetail',
    name: 'inspectionTaskrDetail',
    meta: {
      title: '巡检任务详情'
    },
    component: function component() {
      return import('@/views/safeInspection/inspectionTask/inspectionTaskDetail');
    }
  }],
  hidden: true
}, {
  // 合同打印
  path: '/supplier/supplierInfoPrint',
  name: 'supplier/supplierInfoPrint',
  meta: {
    title: '合同打印'
  },
  component: function component() {
    return import('@/views/supplier/supplierCooperation/components/supplierInfoPrint');
  }
},
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'processIncrease',
//       name: 'processIncrease',
//       component: () =>
//         import('@/views/approveManage/processIncrease')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'processEdit',
//       name: 'processEdit',
//       component: () =>
//         import('@/views/approveManage/processEdit')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'checkProcessDetail',
//       name: 'checkProcessDetail',
//       component: () =>
//         import('@/views/approveManage/checkProcessDetail')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'launchApprovalEdit',
//       name: 'launchApprovalEdit',
//       component: () => import('@/views/approveManage/launchApprovalEdit')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'launchApprovalAgain',
//       name: 'launchApprovalAgain',
//       component: () => import('@/views/approveManage/launchApprovalAgain')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'approvalDetail/exhibition',
//       name: 'approvalDetail/exhibition',
//       component: () => import('@/views/approveManage/approvalDetail/exhibition')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'approvalDetail/operate',
//       name: 'approvalDetail/operate',
//       component: () => import('@/views/approveManage/approvalDetail/operate')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'launchRepairTheory',
//       name: 'launchRepairTheory',
//       component: () => import('@/views/approveManage/launchRepairTheory')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'launchRepairTheoryEdit',
//       name: 'launchRepairTheoryEdit',
//       component: () => import('@/views/approveManage/launchRepairTheoryEdit')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'launchRepairTheoryDetail',
//       name: 'launchRepairTheoryDetail',
//       component: () => import('@/views/approveManage/launchRepairTheoryDetail')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
// {
//   path: '/approveManage',
//   name: 'approveManage',
//   component: Layout,
//   children: [
//     {
//       path: 'relationRepairDetail',
//       name: 'relationRepairDetail',
//       component: () => import('@/views/approveManage/relationRepairDetail')
//     }
//   ],
//   hidden: true,
//   permissionKey: 'approveManage'
// },
/* 暨大改版 */
/* {
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'launchInquiry',
      name: 'launchInquiry',
      component: () => import('@/views/orderManage/launchInquiry')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'inquiryDetail',
      name: 'inquiryDetail',
      component: () => import('@/views/orderManage/inquiryDetail')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'repairDetail',
      name: 'repairDetail',
      component: () => import('@/views/orderManage/repairDetail')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'approvalDetail/exhibition',
      name: 'approvalDetail/exhibition',
      component: () => import('@/views/orderManage/approvalDetail/exhibition')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'approvalDetail/operate',
      name: 'approvalDetail/operate',
      component: () => import('@/views/orderManage/approvalDetail/operate')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'ExpenseAudit',
      name: 'ExpenseAudit',
      component: () => import('@/views/orderManage/ExpenseAudit')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'instrumentCname',
      name: 'instrumentCname',
      component: () => import('@/views/orderManage/instrumentCname')
    }
  ],
  hidden: true
  // permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'supplierProcess',
      name: 'supplierProcess',
      component: () => import('@/views/orderManage/supplierProcess')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'launchInquiryEdit',
      name: 'launchInquiryEdit',
      component: () => import('@/views/orderManage/launchInquiryEdit')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'launchInquiryAgain',
      name: 'launchInquiryAgain',
      component: () => import('@/views/orderManage/launchInquiryAgain')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'launchRepairEdit',
      name: 'launchRepairEdit',
      component: () => import('@/views/orderManage/launchRepairEdit')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'launchRepairAgain',
      name: 'launchRepairAgain',
      component: () => import('@/views/orderManage/launchRepairAgain')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'contract',
      name: 'contract',
      component: () => import('@/views/orderManage/contract')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
},
{
  path: '/orderManage',
  name: 'orderManage',
  component: Layout,
  children: [
    {
      path: 'launchApprovalAgain',
      name: 'launchApprovalAgain',
      component: () => import('@/views/orderManage/launchApprovalAgain')
    }
  ],
  hidden: true,
  permissionKey: 'orderManage'
}, */
{
  // 合同打印
  path: '/orderManage/contractPrint',
  name: 'orderManage/contractPrint',
  meta: {
    title: '合同打印'
  },
  component: function component() {
    return import('@/views/orderManage/contractPrint');
  }
}, {
  path: '/workbench',
  name: 'workbench',
  component: Layout,
  children: [{
    path: 'notice/list',
    name: 'notice/list',
    meta: {
      title: '通知公告'
    },
    component: function component() {
      return import('@/views/workbench/notice/list');
    }
  }, {
    path: 'notice/details',
    name: 'notice/details',
    meta: {
      title: '通知公告详情'
    },
    component: function component() {
      return import('@/views/workbench/notice/details');
    }
  }, {
    path: 'record',
    name: 'record',
    meta: {
      title: '操作日志'
    },
    component: function component() {
      return import('@/views/workbench/record');
    }
  }, {
    path: 'programme',
    name: 'programme',
    meta: {
      title: '我的日程'
    },
    component: function component() {
      return import('@/views/workbench/programme');
    }
  }, /* 暨大改版 */
  {
    path: 'launchRepair',
    name: 'launchRepair',
    meta: {
      title: '发起报修'
    },
    component: function component() {
      return import('@/views/workbench/launchRepair');
    }
  }, {
    path: 'approvalDetail/operate',
    name: 'approvalDetail/operate',
    meta: {
      title: '操作日志'
    },
    component: function component() {
      return import('@/views/workbench/approvalDetail/operate');
    }
  }, {
    path: 'approvalDetail/exhibition',
    name: 'approvalDetail/exhibition',
    meta: {
      title: '查看'
    },
    component: function component() {
      return import('@/views/workbench/approvalDetail/exhibition');
    }
  }, {
    path: 'launchRepairEdit',
    name: 'launchRepairEdit',
    meta: {
      title: '编辑报修'
    },
    component: function component() {
      return import('@/views/workbench/launchRepairEdit');
    }
  }, {
    path: 'checkacceptSettlement',
    name: 'checkacceptSettlement',
    meta: {
      title: '验收'
    },
    component: function component() {
      return import('@/views/workbench/checkacceptSettlement');
    }
  }, {
    path: 'supplierProcess',
    name: 'supplierProcess',
    meta: {
      title: '选择服务商'
    },
    component: function component() {
      return import('@/views/workbench/supplierProcess');
    }
  }, {
    path: 'launchRepairAgain',
    name: 'launchRepairAgain',
    meta: {
      title: '发起报修'
    },
    component: function component() {
      return import('@/views/workbench/launchRepairAgain');
    }
  }, {
    path: 'launchInquiryAgain',
    name: 'launchInquiryAgain',
    meta: {
      title: '发起询价'
    },
    component: function component() {
      return import('@/views/workbench/launchInquiryAgain');
    }
  }, /* 维修维护管理平台_第1期 */
  {
    path: 'releaseRepair',
    name: 'ReleaseRepair',
    meta: {
      title: '报修'
    },
    component: function component() {
      return import('@/views/workTable/releaseRepair');
    }
  },
  // 报修工单详情
  /* {
    path: 'orderDetail/repairDetail',
    name: 'orderDetail/repairDetail',
    component: () => import('@/views/workTable/orderDetail/repairDetail')
  }, */
  {
    path: 'optionalOffer',
    name: 'optionalOffer',
    meta: {
      title: '详情'
    },
    component: function component() {
      return import('@/views/workTable/optionalOffer');
    }
  },
  // 添加贵重仪器论证详情
  {
    path: 'orderDetail/addArgumentation',
    name: 'orderDetail/addArgumentation',
    meta: {
      title: '添加贵重仪器论证详情'
    },
    component: function component() {
      return import('@/views/workTable/orderDetail/addArgumentation');
    }
  },
  // 预算审批、报价审批详情
  {
    path: 'orderDetail/approvalDetail',
    name: 'orderDetail/approvalDetail',
    meta: {
      title: '审批详情'
    },
    component: function component() {
      return import('@/views/workTable/orderDetail/approvalDetail');
    }
  },
  // 预算审批
  {
    path: 'orderDetail/approvalBudgetDetail',
    name: 'orderDetail/approvalBudgetDetail',
    meta: {
      title: '预算审批'
    },
    component: function component() {
      return import('@/views/workTable/orderDetail/approvalBudgetDetail');
    }
  },
  // 报价审批
  {
    path: 'orderDetail/approvalQuoteDetail',
    name: 'orderDetail/approvalQuoteDetail',
    meta: {
      title: '报价审批'
    },
    component: function component() {
      return import('@/views/workTable/orderDetail/approvalQuoteDetail');
    }
  },
  // 经费卡审批
  {
    path: 'orderDetail/approvalFundingCardDetail',
    name: 'approvalFundingCardDetail',
    meta: {
      title: '经费卡审批'
    },
    component: function component() {
      return import('@/views/workTable/orderDetail/approvalFundingCardDetail');
    }
  },
  // 填写报价
  {
    path: 'quotation',
    name: 'quotation',
    meta: {
      title: '填写报价'
    },
    component: function component() {
      return import('@/views/workTable/quotation');
    }
  }, {
    path: 'orderDetail/acceptanceDetail',
    name: 'orderDetail/acceptanceDetail',
    meta: {
      title: '验收单详情'
    },
    component: function component() {
      return import('@/views/workTable/orderDetail/acceptanceDetail');
    }
  }, {
    path: 'orderDetail/settleDetail',
    name: 'orderDetail/settleDetail',
    meta: {
      title: '结算单详情'
    },
    component: function component() {
      return import('@/views/workTable/orderDetail/settleDetail');
    }
  }, {
    path: 'settleSummaryRecode',
    name: 'settleSummaryRecode',
    meta: {
      title: '结算汇总单详情'
    },
    component: function component() {
      return import('@/views/workTable/settleSummary/pages/orderRecode');
    }
  }],
  hidden: true,
  permissionKey: 'notice'
}, {
  path: '/dataStatistics',
  name: 'dataStatistics',
  component: Layout,
  children: [{
    path: 'billDetail',
    name: 'billDetail',
    meta: {
      title: '详情'
    },
    component: function component() {
      return import('@/views/dataStatistics/billDetail');
    }
  }],
  hidden: true
}, {
  path: '/sparePartsManage',
  name: 'sparePartsManage',
  component: Layout,
  hidden: true,
  meta: {
    title: '备件管理'
  },
  children: [{
    path: 'mainDetail',
    name: 'mainDetail',
    meta: {
      title: '入库单详情'
    },
    component: function component() {
      return import('@/views/sparePartsManage/warehousingManage/components/mainDetail');
    }
  }, {
    path: 'sparePartsDetail',
    name: 'sparePartsDetail',
    meta: {
      title: '备件资料详情'
    },
    component: function component() {
      return import('@/views/sparePartsManage/sparePartsInfo/sparePartsDetail/index');
    }
  }, {
    path: 'inventoryDetails',
    name: 'inventoryDetails',
    meta: {
      title: '盘点单'
    },
    component: function component() {
      return import('@/views/sparePartsManage/inventorySheet/components/mainDetail');
    }
  }, {
    path: 'stockDetails',
    name: 'stockDetails',
    meta: {
      title: '移库单'
    },
    component: function component() {
      return import('@/views/sparePartsManage/stockTransferOrder/components/mainDetail');
    }
  }, {
    path: 'sparePartsUse/mainDetail',
    name: 'sparePartsUse/mainDetail',
    meta: {
      title: '领用单详情'
    },
    component: function component() {
      return import('@/views/sparePartsManage/sparePartsUseManage/components/mainDetail');
    }
  }]
}, {
  path: '/maintenanceService',
  name: 'maintenanceService',
  component: Layout,
  hidden: true,
  meta: {
    title: '维保服务'
  },
  children: [{
    path: 'maintenanceDetail',
    name: 'maintenanceDetail',
    meta: {
      title: '维保服务详情'
    },
    component: function component() {
      return import('@/views/maintenanceService/components/MaintenanceDetail');
    }
  }]
}, {
  path: '/leaseManage',
  name: 'leaseManage',
  component: Layout,
  hidden: true,
  meta: {
    title: '仪器租赁'
  },
  children: [{
    path: 'leaseDetail',
    name: 'leaseDetail',
    meta: {
      title: '租赁详情'
    },
    component: function component() {
      return import('@/views/leaseManage/leaseDevice/pages/leaseDetail');
    }
  }]
}, {
  path: '/recommendManage',
  name: 'recommendManage',
  component: Layout,
  hidden: true,
  meta: {
    title: '仪器推介'
  },
  children: [{
    path: 'recommendDetail',
    name: 'recommendDetail',
    meta: {
      title: '仪器推介详情'
    },
    component: function component() {
      return import('@/views/recommendManage/recommend/pages/recommendDetail');
    }
  }, {
    path: 'trialApplicationDetail',
    name: 'trialApplicationDetail',
    meta: {
      title: '试用详情'
    },
    component: function component() {
      return import('@/views/recommendManage/trialApplication/pages/trialApplicationDetail');
    }
  }]
}, {
  path: '/instrumentSparePartsZone',
  name: 'instrumentSparePartsZone',
  component: Layout,
  hidden: true,
  meta: {
    title: '备件专区'
  },
  children: [{
    path: 'instrumentSparepartDetail',
    name: 'instrumentSparepartDetail',
    meta: {
      title: '备件信息详情'
    },
    component: function component() {
      return import('@/views/instrumentSparePartsZone/instrumentSpareparts/pages/instrumentSparepartDetail');
    }
  }]
}, {
  path: '/learningZone',
  name: 'learningZone',
  component: Layout,
  hidden: true,
  meta: {
    title: '学习专区'
  },
  children: [{
    path: 'courseInfoDetail',
    name: 'courseInfoDetail',
    meta: {
      title: '课程信息详情'
    },
    component: function component() {
      return import('@/views/learningZone/courseInfo/courseInfoDetail');
    }
  }]
}];
var baseObj = process.env.VUE_APP_ENV === 'productionc' ? {
  base: process.env.VUE_APP_SRC
} : {};

// 配置/home步骤：1、修改vue.config.js中的publicPath；2、放开base和mode
var createRouter = function createRouter() {
  return new Router(_objectSpread(_objectSpread({}, baseObj), {}, {
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      // history.pushState(null, null, document.URL)
      return {
        y: 0
      };
    },
    routes: constantRoutes
  }));
};
var router = createRouter();

// 清理所有tooltip的函数
function clearTooltips() {
  var tooltips = document.querySelectorAll('.el-tooltip__popper');
  tooltips.forEach(function (tooltip) {
    tooltip.remove();
  });
}

// 全局前置守卫：路由跳转前清理所有tooltip，避免悬浮框残留
router.beforeEach(function (to, from, next) {
  // 立即清理一次
  clearTooltips();

  // 设置定时器，持续清理直到页面跳转完成（最多清理5次，每次50ms）
  var count = 0;
  var interval = setInterval(function () {
    clearTooltips();
    count++;
    if (count >= 5) {
      clearInterval(interval);
    }
  }, 80);
  next();
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;